import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CrudService } from '../../../../core';
import { RecursoCampanha } from '../recurso-campanha';

@Injectable({
    providedIn: 'root'
})
export class RecursoCampanhaCrudHttpService {
    resource = 'recursoCampanha';

    constructor(private crudService: CrudService) { }

    /** Procura um único recurso de campanha através do seu ID */
    find(id: number): Observable<RecursoCampanha> {
        return this.crudService.find<RecursoCampanha>(this.resource, id);
    }

    /** Carrega um único recurso de campanha através do seu ID */
    load(id: number): Observable<RecursoCampanha> {
        return this.crudService.load<RecursoCampanha>(this.resource, id);
    }

    /** Insere um novo recurso de campanha */
    insert(entity: RecursoCampanha): Observable<RecursoCampanha> {
        return this.crudService.insert<RecursoCampanha>(this.resource, entity);
    }

    /** Altera uma recurso de campanha existente */
    update(entity: RecursoCampanha): Observable<RecursoCampanha> {
        return this.crudService.update<RecursoCampanha>(this.resource, entity);
    }

    /** Exclui uma recurso de campanha através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
